import React, { Component } from 'react';
interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}
interface State {
  hasError: boolean;
}
export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };
  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }
  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return <div className="p-6 bg-red-50 rounded-lg max-w-md mx-auto mt-10 text-center" data-id="element-148">
          <h2 className="text-xl font-bold text-red-700 mb-4" data-id="element-149">
            Algo salió mal
          </h2>
          <p className="text-gray-700 mb-4" data-id="element-150">
            Por favor, intenta recargar la página.
          </p>
          <button onClick={() => window.location.reload()} className="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded" data-id="element-151">
            Recargar página
          </button>
        </div>;
    }
    return this.props.children;
  }
}